// store/comunes/index.js

//inicio storage
const STORAGE_POPUP_AVISO = 'leon_comunes_popup_aviso_mostrado';

const getInfoPopup = () => {
  try {
    if (import.meta.client) {
      const mostrado = sessionStorage.getItem(STORAGE_POPUP_AVISO);
      return mostrado ? JSON.parse(mostrado) : false;
    }
  } catch (error) {
    console.warn('Error leyendo estado de popup:', error);
  }
  return false;
};

const setToStorage = (storage, data) => {
  try {
    if (import.meta.client) {
      sessionStorage.setItem(storage, JSON.stringify(data));
    }
  } catch (error) {
    console.warn('Error guardando en sessionStorage:', error);
  }
};
//termino storage

//#region inicio state
const state = function() {
  return {
    load_carrusel: false,
    PopupAvisoMostrado: false,
  };
};
//#endregion termino state

//#region inicio mutations
const mutations = {
  cargarStorage: function(state) {
    const storedData = getInfoPopup();
    state.PopupAvisoMostrado = storedData;
    console.log('[STORE] Estado cargado desde sessionStorage para PopupAvisoMostrado:', state.PopupAvisoMostrado);
  },

  setload_carrusel: function(state, bandera) {
    state.load_carrusel = bandera;
  },

  setPopupAvisoMostrado: function(state) {
    state.PopupAvisoMostrado = true;
    setToStorage(STORAGE_POPUP_AVISO, true);
  },
};
//#endregion termino mutations

//#region inicio getters
const getters = {
  getPopupAvisoMostrado: function(state) {
    return state.PopupAvisoMostrado;
  },
};
//#endregion termino getters

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {}
};